import api from './client';

// University Hub API
export const universityAPI = {
  // Auth
  login: async (email, password) => {
    const response = await api.post('/university-hub/login', { email, password });
    return response.data;
  },

  register: async (data) => {
    const response = await api.post('/university-hub/register', data);
    return response.data;
  },

  // Dashboard
  getStats: async (universityId) => {
    const response = await api.get(`/university-hub/dashboard/stats?university_id=${universityId}`);
    return response.data;
  },

  getAnalytics: async (universityId, period = '30d') => {
    const response = await api.get(`/university-hub/analytics?university_id=${universityId}&period=${period}`);
    return response.data;
  },

  // Applications
  getApplications: async (universityId, status = null) => {
    let url = `/university-hub/applications?university_id=${universityId}`;
    if (status) url += `&status=${status}`;
    const response = await api.get(url);
    return response.data;
  },

  getApplicationDetails: async (applicationId, universityId) => {
    const response = await api.get(`/university-hub/applications/${applicationId}?university_id=${universityId}`);
    return response.data;
  },

  makeDecision: async (applicationId, universityId, decision, message = null, scholarship = null) => {
    const response = await api.post(`/university-hub/applications/${applicationId}/decision?university_id=${universityId}`, {
      application_id: applicationId,
      decision,
      message,
      scholarship_offered: scholarship,
    });
    return response.data;
  },

  sendMessage: async (applicationId, universityId, message) => {
    const response = await api.post(`/university-hub/applications/${applicationId}/message?university_id=${universityId}`, null, {
      params: { message },
    });
    return response.data;
  },

  // Profile
  getProfile: async (universityId) => {
    const response = await api.get(`/university-hub/profile?university_id=${universityId}`);
    return response.data;
  },

  updateProfile: async (universityId, updates) => {
    const response = await api.put(`/university-hub/profile?university_id=${universityId}`, updates);
    return response.data;
  },

  // Membership
  applyForMembership: async (data) => {
    const response = await api.post('/university-hub/membership/apply', data);
    return response.data;
  },
};

export default universityAPI;
